export interface IContactSearchApiModel {
    name: string;
    filerId: number;
    roleId: number;
    stateCode: string;
    denver: boolean;
    typeId: number;
    pageSize: number;
    page: number;
    sortOn: string;
    descending: boolean;
    filters: any;
}
export interface ApiResponse<T = any> {
    code?: number;
    errorCode: number;
    pkId?: number;
    requestKey: string;
    message: string;
    detail: string;
    result: T;
    hasError: boolean;
    requestTime: any;
    messageCode?: number;
}

export interface FilingStatusUpdateRequestApiModel {
    filingId: number;
    filingStatusId: number;
    notes: string;
}
export interface UserInformation {
    id: string;
    email: string;
    firstName?: any;
    middleName?: any;
    lastName?: any;
    orgName?: any;
    address1?: any;
    address2?: any;
    city?: any;
    stateCode?: any;
    countryCode?: any;
    zip?: any;
    phone?: any;
    occupation?: any;
    externalContactID?: any;
    description?: any;
    altphone?: any;
    altemail?: any;
    committees: Committees[];
    accessEthicses: AccessEthicses[];
}

export interface Committees {
    committeeId: number;
    name?: any;
    ballotIssueNotes?: any;
    position?: any;
    committeeTypeId: number;
    committeeTypeName?: any;
    officeSoughtId?: any;
    districtId?: any;
    electionCycleId?: any;
    campaignWebsite?: any;
    purpose?: any;
    bankName?: any;
    bankAddress1?: any;
    bankAddress2?: any;
    bankCity?: any;
    bankStateCode?: any;
    bankZip?: any;
    adminNotes?: any;
    committeeRegistrationStatusId: number;
    committeeRegistrationStatusName?: any;
    ballotIssueId?: any;
    filerId: number;
    committeeUserId: number;
    committeeUserRoleId?: any;
    committeeUserRoleName?: any;
    committeeUserTypeId: number;
    committeeUserTypeName?: any;
    committeeUserStatusId: number;
    committeeUserStatusName?: any;
    applicationUserId?: any;
    applicationUserFullName?: any;
    isAdmin: boolean;
}

export interface AccessEthicses {
    accessEthicsId: number;
    accessEthicsTypeId: number;
    accessEthicsTypeName?: any;
    appointingAuthorityId?: any;
    appointingAuthorityName?: any;
    officeId?: any;
    officeName?: any;
    department?: any;
    title?: any;
    personalEmail?: any;
    personalPhone?: any;
    comments?: any;
    secondaryEmail?: any;
    personalContactId: number;
    filerId: number;
    accessEthicsUserId: number;
    accessEthicsUserRoleId: number;
    accessEthicsUserRoleName?: any;
    accessEthicsUserTypeId: number;
    accessEthicsUserTypeName?: any;
    accessEthicsUserStatusId: number;
    accessEthicsUserStatusName?: any;
    applicationUserId?: any;
    applicationUserFullName?: any;
    isAdmin: boolean;
}
export interface UserEntity {
    userInformation: UserInformation;
}

export interface UserMenuResponseApiModel {
    isAdmin: boolean;
    userFilersResponseApiModels: UserFilers[];
}

export interface SelectedFiler {
    isAdmin: boolean;
    selectedFiler: UserFilers;
}

export interface UserFilers extends BaseFilerModel {
    isPrimary?: boolean;
    isActive?: boolean;
    candidateCheck?: boolean;
    entityTypeId?: number;
    committeeTypeId?: number;
    filingStatusId?: number;
    filingPeriodId?: number;
    electionCycleId?: number;
    filingNotes?: string;
    isRequiredToFileCampaignFinanceReports?: boolean;
}

export interface UserApiModel {
    id: string;
    firstName: string;
    middleName: string;
    lastName: string;
    email: string;
    orgName: string;
    address1: string;
    address2: string;
    city: string;
    stateCode: string;
    countryCode: string;
    zip: string;
    phone: string;
    occupation: string;
    externalContactID: string;
    description: string;
    altphone: string;
    altemail: string;
    IsSamlUser: boolean;
    isAdmin?: boolean;
    bussinesAddress: string;
}

export interface TypeResponseApiModel {
    id: number;
    name: string;
}

export interface DistrictResponseApiModel {
    districtId: number;
    createdAt: Date;
    name: string;
    officeId: number;
    officeDistrictName: string
}

export interface IFilingPeriodByElectionCycleApiModel
    extends TypeResponseApiModel {
    hasDraftFiling?: boolean;
    dueDate?: Date;
    startDate?: Date;
    endDate?: Date;
}

export interface StateListResponseApiModel {
    stateCode: string;
    stateName: string;
}

export interface AddOfficeApiModel {
    officeId: number;
    name: string;
}

export interface CommitteeList {
    committeeId: number;
    name: string;
    position: string;
}

export interface ElectionCycleDDResponseApiModel {
    electionCycleId: number;
    name: string;
}

export interface CampaignFinanceElectionCycleDropdownModel {
    id: number;
    name: string;
    fecha: any;
}

export interface CalendarEventsApiModel {
    electionCycleDetails: CalendarApiModel[];
    eventDetails: CalendarApiModel[];
    filingPeriodDetails: CalendarApiModel[];
}

export interface CalendarApiModel {
    title: string;
    description: string;
    startDate: Date;
    endDate: Date;
    eDate: Date;
    runoffDate: Date;
    filerTypeId: number;
    filerTypeName: string;
}

export interface FilerTypeResponseApiModel {
    id: number;
    name: string;
    description: string;
}

export interface ElectionDateResponseApiModel {
    electionCycleId: number;
    electionCycleTypeId: number;
    electionDate: Date;
}

export interface BaseFilerModel {
    filerId: number;
    filerTypeId: number;
    entityId: number;
    entityName: string;
    entityType?: string;
    filingId: number;
    filingTypeId?: number;
    filingTypeName?: string;
}

export interface SimpleFilerModel {
    filerId: number;
    entityId: number;
    name: string;
}

export interface Contributions {
    transactionId: number;
    date?: Date;
    amount: number;
    description: string;
    contributorName?: string;
    contributorId: number;
    contributorType?: string;
    contactTypeId: number;
    contributionTypeId?: number;
    filerTypeId: number;
    cycleToDateTotal: number;
    unitemizedTotal: number;
    address1?: string;
    address2?: string;
    city?: string;
    stateCode?: string;
    zip?: string;
    employer?: string;
    occupation?: string;
    voterId?: string;
    receiptUrl: string;
    attachmentId?: number;
    committeeTypeId?: number;
    loanId?: number;
}

export interface ExpenditureTransactionsResponseModel extends Contributions {
    payeeName: string;
    payeeId: number;
    payeeType: string;
    payeeTypeId: number;
    filerTypeId: number;
    purpose: string;
    occupation: string;
    expenditureCategoryId: number;
    expendituresCategory: string;
    fairElectionFund: string;
    fairElectionFundFlag: boolean;
  }

export interface MonetaryContributionsResponseModel extends Contributions {
    contributionLimitError: boolean;
}

export interface ContributionListModel {
    data: MonetaryContributionsResponseModel[];
    unitemizedTotal: number;
    limitErrors: number
}

export interface ExpenditureListModel {    
    data: ExpenditureTransactionsResponseModel[];
    unitemizedTotal: number;
}
export interface CityStateListResponseApiModel {
    city: string;
    state: string;
}

export interface DropDownApiModel {
    id: string;
    name: string;
}

export interface CommitteeDetails {
    bankName: string;
    bankAddress1: string;
    bankAddress2: string;
    bankCity: string;
    bankStateName: string;
    bankZip: string;
}

export interface ValidateApiModel<T> {
    data: T
}

export interface ValidateResponseApiModel<T> {
    valid: boolean;
    errors: T;
}

export interface ExpenditureIndependentTransactions {
    transactionId: number;
    date?: Date;
    amount: number;
    payeeName: string;
    payeeType: string;
    address1?: string;
    address2?: string;
    city?: string;
    stateCode?: string;
    zip?: string;
    purpose: string;
    targetType: string;
    targetName?: string;
    officeSought: string;
    district?: string;
    position: string;
    parentTransactionId?: number;
    fileUrl: string;
    attachmentId?: number;
}

export interface CampaignReportOptionModel {
    buttonType: number;
    isActive: boolean;
}

export interface UnitemizedInfo {
    unitemizedMonetaryContributions: number;
    unitemizedInKindContributions: number;
}

export interface CampaignFinanceReportSummaryInfoResponseApiModel{
    openingBalance: number;
    totalMonetaryContributions: number;
    totalInKindContributions: number;
    totalExpenditures: number;
    closingBalance: number;
    unitemizedMonetaryContributions: number;
    unitemizedInKindContributions: number;
    totalFEFQualifyingContributions: number;
    totalRefunds: number;
    totalFairElectionExpenditures: number;
    totalOtherExpenditures: number;
    totalFairElectionsFunding: number;
    totalNewLoans: number;
    hasFEFRows: boolean;
    isFinalReport: boolean;
    isFilingPeriodAvailableForAmendments: boolean;
    itemizationThreshold: number;
    unitemizedExpenditures: number;
    campaignReportType: number;
}